import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
declare var $: any;

@Component({
    selector: 'app-summernote-textbox',
    template: `
        <div [formGroup]="parentForm">
            <textarea formControlName="message" id="summernote"></textarea>
        </div>
    `
})
export class SummernoteTextboxComponent {
    @Input() parentForm: FormGroup;

    constructor() {}

    public ngAfterViewInit(): void {
        this.initSummerNote();
    }

    private initSummerNote() {
        $('#summernote').summernote({
            height: 500,
            tooltip: true,
            tabsize: 2,
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link', 'picture', 'video', 'table']],
                ['view', ['codeview', 'help']]
            ],
            callbacks: {
                onChange: (contents: string) => {
                    this.parentForm.controls['message'].setValue(this.cleanHtml(contents));
                },
                  onBlurCodeview: () => {
                    let codeContents = $('#summernote').summernote('code');
                    this.parentForm.controls['message'].setValue(this.cleanHtml(codeContents));
                }
            }
        });
    }

    private cleanHtml(bodyValue: string): string {
        let cleanedBodyValue = bodyValue
            .replace(/\n+/g, '')
            .replace(/\r+/g, '')
            .replace(/\s{2,}/g, ' ')
            .trim();

        return cleanedBodyValue;
    }
}